import { h, Component } from 'preact';
import { route } from 'preact-router';
import TicketLogic from '../utils/ticket-logic.jsx';

export default class RecallBet extends Component {
    componentWillMount() {
        if (this.props.betId) {
            TicketLogic.loadReservedTicket(this.props.betId, (err, res) => {
                if (err) {
                    console.error("Error loading reserved ticket:", err);
                }
                // Redirect to home page to show the loaded ticket in the betslip
                route('/', true);
            });
        }
    }

    render() {
        return null; // This component does not render anything
    }
}